module.exports = __webpack_public_path__ + "media/icons/naprawa-82576cb2.png";